<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <h3>Departures</h3>
      <p>
        <md-button
          @click.prevent="downloadReportData"
          class="md-primary md-sm download-button"
          >Download CSV</md-button
        >
      </p>
    </div>

    <div class="md-layout-item md-size-100">
      <h6>Summary</h6>
      <div class="md-layout">
        <div
          v-for="(data, curr) in summary"
          :key="curr"
          class="md-layout-item md-size-20"
        >
          <report-financial-summary :currency="curr" :data="data" />
        </div>
      </div>
    </div>

    <div class="md-layout-item md-size-100">
      <md-table id="report-data" v-model="reportData" md-card>
        <md-table-row
          slot="md-table-row"
          slot-scope="{ item }"
          md-selectable="single"
        >
          <md-table-cell md-label="Customer">{{ item.Customer }}</md-table-cell>
          <md-table-cell md-label="Tour">{{ item.Tour }}</md-table-cell>
          <md-table-cell md-label="Departure">{{
            item.Departure | formatDate
          }}</md-table-cell>
          <md-table-cell md-label="Booking Date">{{
            item.BookingDate | formatDate
          }}</md-table-cell>
          <md-table-cell md-label="Currency">{{ item.Currency }}</md-table-cell>
          <md-table-cell md-label="Cost">{{
            item.TotalCost.toFixed(2)
          }}</md-table-cell>
          <md-table-cell md-label="Paid">{{
            item.AmountPaid.toFixed(2)
          }}</md-table-cell>
          <md-table-cell md-label="Balance">{{
            item.Balance.toFixed(2)
          }}</md-table-cell>
          <md-table-cell md-label="Due Date">{{
            item.BalanceDue | formatDate
          }}</md-table-cell>
          <md-table-cell md-label="Travellers">{{
            item.Travellers
          }}</md-table-cell>
        </md-table-row>

        <md-table-empty-state
          md-label="Nothing to Show"
          :md-description="`There's no data for this report.`"
        ></md-table-empty-state>
      </md-table>
    </div>
  </div>
</template>

<script>
import reportApi from "@/services/api/report";
import moment from "moment";
import ReportFinancialSummary from "@/pages/Reporting/ReportFinancialSummary";

export default {
  data() {
    return {
      reportData: [],
      summary: {}
    };
  },

  props: {
    startDate: null,
    endDate: null
  },

  components: {
    ReportFinancialSummary
  },

  methods: {
    getReportData() {
      reportApi
        .departures({
          startDate: this.startDate,
          endDate: this.endDate
        })
        .then(response => {
          this.reportData = response.data.reportData;
          this.summary = response.data.summary;
        });
    },

    downloadReportData() {
      reportApi
        .departures({
          startDate: this.startDate,
          endDate: this.endDate,
          download: true
        })
        .then(response => {
          let filename = `sales_${moment().format("YYMMDD")}.csv`;
          reportApi.download(response, filename);
        });
    }
  },

  mounted() {
    this.getReportData();
  }
};
</script>
